import { createAction, createRequestActions } from "common/helpers/action";

export const setChildCompany = createAction("COMPANY.SET_CHILD_COMPANY");
export const initCompanyList = createRequestActions("COMPANY.LIST.INIT");
